var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"spinner",attrs:{"src":require('@/assets/onboarding/spinner-big.svg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }